import { useGeolocationStore } from '/src/store/stores/useGeolocationStore.js';
import { useNativeGeolocation } from '/src/native/useNativeGeolocation.js';

// device
const {
	setPosition,
} = useGeolocationStore();

// network
const {
	checkPermissions,
	watchPosition,
	clearWatch,
} = useNativeGeolocation();

export function useGeolocationService () {
	let watchCallbackId;

	async function start () {
		stop();

		const { location } = await checkPermissions();
		if (location === 'denied') {
			return;
		}

		watchCallbackId = await watchPosition({
			maximumAge: 300000,
			timeout: 60000,
			enableHighAccuracy: true,
		}, (position) => {
			if (!position) {
				return;
			}

			setPosition(position);
		});
	}

	function stop () {
		if (watchCallbackId) {
			clearWatch({ id: watchCallbackId });
			watchCallbackId = null;
		}
	}

	return {
		start,
		stop,
	};
}
